import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=4bedd77c"
import script from "./SfInput.vue?vue&type=script&lang=js"
export * from "./SfInput.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfInput.vue?vue&type=style&index=0&id=4bedd77c&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "9d15da92"
  
)

export default component.exports